import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHomeData } from "../../redux/actions/dataActions";
import phone from "../../assets/images/phone.svg";
import user from "../../assets/images/user.svg";
import mail from "../../assets/images/mail.svg";

import "./Details.css";
import { Card, CardContent, CardHeader } from "@mui/material";
import { Title } from "@mui/icons-material";

function Details(props) {
  return (
    <Card className="details-card">
      <CardHeader className="details-title" titleTypographyProps={{fontSize:'16px'}} title={props.title}>
      </CardHeader>
      <CardContent className='details-row'>
       {props.data?.name && <div>
          <img src={user} /> {props.data?.name}
        </div>
        }
        
       {props.data?.tel && <div>
          <img src={phone} /> {props.data?.tel}
        </div>
        
        }
       {props.data?.mail&&<div className="english">
          <img src={mail} /> {props.data?.mail}
        </div>} 
      </CardContent>
    </Card>
    //     <div className="details-card">

    //         <div className='details-title'>
    //            <div> {props.title}</div>
    //         </div>
    //         <div className='details-row'>
    //             <div><img src={user} /> {props.data?.name}</div>
    //             <div><img src={phone} /> {props.data?.tel}</div>
    //             <div><img src={mail} /> {props.data?.mail}</div>
    //         </div>
    //   </div>
  );
}

export default Details;
